// extracted by mini-css-extract-plugin
module.exports = {"footer":"_95JTu","containerMenu":"_1Gaii","containerLinks":"_1agVB"};